
export default function EmotionalConnection() {
  const painPoints = [
    { icon: 'ri-map-pin-line', text: 'Medo de se perder em uma cidade desconhecida' },
    { icon: 'ri-translate', text: 'Barreira do idioma causando estresse e confusão' },
    { icon: 'ri-money-dollar-circle-line', text: 'Gastar dinheiro em armadilhas turísticas' },
    { icon: 'ri-calendar-close-line', text: 'Planejamento ruim levando a experiências perdidas' },
    { icon: 'ri-time-line', text: 'Não saber os melhores horários para visitar as atrações' }
  ];

  const solutions = [
    { 
      icon: 'ri-user-voice-line', 
      title: 'Suporte em Português', 
      description: 'Comunique-se confortavelmente no seu idioma nativo durante toda a sua jornada' 
    },
    { 
      icon: 'ri-lightbulb-flash-line', 
      title: 'Planejamento Inteligente e Personalizado', 
      description: 'Roteiros sob medida criados de acordo com seus interesses, ritmo e estilo de viagem' 
    },
    { 
      icon: 'ri-map-2-line', 
      title: 'Conhecimento Local Privilegiado', 
      description: 'Acesso a lugares escondidos e experiências autênticas que só os moradores conhecem' 
    },
    { 
      icon: 'ri-timer-flash-line', 
      title: 'Otimização de Tempo', 
      description: 'Programação estratégica para aproveitar ao máximo seu tempo e ver mais com menos estresse' 
    },
    { 
      icon: 'ri-wallet-3-line', 
      title: 'Decisões Econômicas Inteligentes', 
      description: 'Orientação especializada sobre onde gastar e onde economizar para o melhor custo-benefício' 
    },
    { 
      icon: 'ri-shield-check-line', 
      title: 'Tranquilidade Total', 
      description: 'Suporte antes, durante e após a viagem para uma experiência sem preocupações' 
    }
  ];

  return (
    <section className="bg-[#0f0f0f] py-24 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage:
            'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-5 gap-16 items-start">
          {/* Pain Points - Left Side */}
          <div className="lg:col-span-2 space-y-8">
            <h2 className="text-3xl lg:text-4xl font-serif font-bold leading-tight">
              Viajar para Nova York
              <br />
              Não Deveria Ser
              <br />
              <span className="text-[#D4AF37]">Estressante</span>
            </h2>

            <div className="space-y-4">
              {painPoints.map((point, index) => (
                <div
                  key={index}
                  className="bg-[#1a1a1a] rounded-lg p-5 flex items-start gap-4 border-l-4 border-[#8B0000] hover:border-[#D4AF37] transition-all duration-300"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-[#8B0000]/20 rounded-full flex-shrink-0">
                    <i className={`${point.icon} text-xl text-[#ff4444]`}></i>
                  </div>
                  <p className="text-white/90 text-base leading-relaxed pt-1">{point.text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Solutions - Right Side */}
          <div className="lg:col-span-3 space-y-8">
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold leading-tight mb-4">
                A PremierNY Transforma
                <br />
                a Sua Jornada
              </h2>
              <div className="w-16 h-1 bg-[#D4AF37]"></div>
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              {solutions.map((solution, index) => (
                <div
                  key={index}
                  className="bg-black rounded-lg p-4 border-l-4 border-[#D4AF37] hover:shadow-lg hover:shadow-[#D4AF37]/20 transition-all duration-300 group"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37]/10 rounded-full mb-3 group-hover:bg-[#D4AF37]/20 transition-colors">
                    <i className={`${solution.icon} text-xl text-[#D4AF37]`}></i>
                  </div>
                  <h3 className="text-base font-bold mb-2 text-white">{solution.title}</h3>
                  <p className="text-gray-400 text-xs leading-relaxed">{solution.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
